
export default class listService {

    constructor (listItems){
        this.items = listItems;
        this.selectedIds = [];
        this.selectedItems = [];
        this.last_checked_index = null;
    }

    toggleArticle (item){
        var idx = this.selectedIds.indexOf(item.id)
        if (idx > -1) {
            this.selectedIds.splice(idx, 1)
            this.selectedItems.splice(idx, 1)
            return false;
        } else {
            this.selectedIds.push(item.id)
            this.selectedItems.push(item)
            return true;
        }

    }

    toggleArticleOn (item){
        var idx = this.selectedIds.indexOf(item.id)
        if (idx === -1) {
            this.selectedIds.push(item.id)
            this.selectedItems.push(item)
        }

    }

    toggleArticleOff (item){
        var idx = this.selectedIds.indexOf(item.id)
        if (idx > -1) {
            this.selectedIds.splice(idx, 1)
            this.selectedItems.splice(idx, 1)
        }
    }

    toggleAll (){
        if(this.selectedIds.length === this.items.length){
            this.selectedIds = [];
            this.selectedItems = []
        }else{
            for (var index=0; index<this.items.length; index++){
                var item = this.items[index]
                var idx = this.selectedIds.indexOf(item.id);
                if (idx === -1) {
                    this.selectedIds.push(item.id);
                    this.selectedItems.push(item)
                }
            }
        }
    }

    toggle ($e, item) {
        var new_index = this.items.indexOf(item);
        var old_index = this.last_checked_index;

        var is_on = this.toggleArticle(item);

        this.last_checked_index = this.items.indexOf(item);

        if($e.shiftKey && old_index !== null){
            if(old_index < new_index){
                for(var i=old_index; i<new_index; i++){
                    if(is_on){
                        this.toggleArticleOn(this.items[i])
                    }else{
                        this.toggleArticleOff(this.items[i])
                    }
                }
            }
            if(old_index > new_index){
                for(var j=new_index; j<old_index+1; j++){
                    if(is_on){
                        this.toggleArticleOn(this.items[j])
                    }else{
                        this.toggleArticleOff(this.items[j])
                    }
                }
            }
        }
    }
}